import { render } from "./JarsBlackTheParnasGold_2025.vue?vue&type=template&id=43c2f1a2"
const script = {}

import exportComponent from "/Users/taesungkim/Git/parnas-app-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__